import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import PublicRoute from './components/auth/PublicRoute';
import ResetRoute from './components/auth/ResetRoute';
import Login from './components/auth/Login';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import Profile from './components/auth/Profile';
import Layout from './components/layout/Layout';
import AppLauncher from './components/apps/AppLauncher';
import ApiListing from './components/admin/ApiListing';

function App() {
  return (
    <AuthProvider>
      <Router basename="/portal" future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          {/* Public routes — redirect to /apps if already logged in */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <PublicRoute>
                <ForgotPassword />
              </PublicRoute>
            }
          />

          {/* Reset route — validates token from query params before rendering */}
          <Route
            path="/reset"
            element={
              <ResetRoute>
                <ResetPassword />
              </ResetRoute>
            }
          />

          {/* Protected routes — wrapped in Layout with sidebar */}
          <Route
            path="/apps"
            element={
              <ProtectedRoute>
                <Layout>
                  <AppLauncher />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Layout>
                  <Profile />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/api-listing"
            element={
              <ProtectedRoute>
                <Layout>
                  <ApiListing />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/apps" replace />} />
          <Route path="*" element={<Navigate to="/apps" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
